import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    properties: {
      // address: {},
      // entities: {},
      // pagination: {}
    },
    filters: [],
    propertyTypeId: null,
    homeStyleAnswers: [],
    layout: "default-layout",

    // for redirect HomeOwners after signUp
    isSignUp: false,

    twilioMessagesCounter: null,
    isInitTwilio: null,

    user: {
      id: "",
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      unconfirmedEmail: "",
      unconfirmedPhone: "",
      role: "",
      avatar: "",
      background: "",
      licence: "",
      aboutMe: "",
      propertyTypes: "",
      brokerName: "",
      needUploadAgentDocuments: false,
      agentLocations: [],
      tcpaAccepted: false,
      // buyerLocation: {},
      twillioIdentity: "",
      refusedToBeLead: false,
      showAnalytic: false,
      agentDocuments: [],
      preferences: {
        tagId: "",
        title: "",
        icon: "",
        value: ""
      },
      specialties: "",
      facebook: "",
      linkedin: "",
      agentSince: "",
      brokerageAddress: "",
      otherLicenses: "",
      businessPhone: "",
      brokeragePhone: "",
      managingBrokerName: "",
      brokerLicenseNumberAndState: "",
      licenceApproved: false
    }
  },
  mutations: {
    setProperties(state, {properties, isPagination}) {
      if (isPagination)
        properties.entities = state.properties.entities.concat(properties.entities)
      state.properties = properties;
    },

    pushHomeStyleAnswer(state, answer) {
      let currentIndex = null;

      currentIndex = state.homeStyleAnswers.findIndex(
        f => f.tagId == answer.tagId
      );

      if (currentIndex >= 0) {
        state.homeStyleAnswers[currentIndex] = answer;
      } else {
        state.homeStyleAnswers.push(answer);
      }
    },

    setPropertyTypeId(state, id) {
      state.propertyTypeId = id;
    },

    setIsSignUp(state, type) {
      state.isSignUp = type;
    },

    setFilters(state, filters) {
      localStorage.setItem("searchParams", JSON.stringify(filters));

      state.filters = filters;
    },

    setLayout(state, payload) {
      state.layout = payload;
    },

    setUser(state, user) {
      state.user = user;
    },

    setUserPhone(state, phone) {
      state.user.phone = phone;
    },

    setUserAvatar(state, avatar) {
      state.user.avatar = avatar;
    },

    setUserEmail(state, email) {
      state.user.email = email;
    },

    setUserIDocuments(state, document) {
      state.user.agentDocuments.push(document);
    },

    setUserInfo(state, user) {
      state.user = Object.assign(state.user, user);
    },

    setTwilioMessagesCounter(state, counter) {
      state.twilioMessagesCounter = counter;
    },

    setIsInitTwilio(state, status) {
      state.isInitTwilio = status;
    }
  },

  actions: {
    initUser({ commit }, user) {
      // window.Intercom("shutdown");
      commit("setUser", user);

      if (window.Intercom) {
        window.Intercom("update", {
          name: user.fullName,
          user_id: user.id,
          email: user.email,
          phone: user.phone
        });
      }
    },

    destroyUser({ commit }) {
      localStorage.removeItem("AUTH_TOKEN");
      localStorage.removeItem("searchParams");

      const user = {
        id: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        unconfirmedEmail: "",
        unconfirmedPhone: "",
        role: "",
        avatar: "",
        background: "",
        licence: "",
        aboutMe: "",
        propertyTypes: "",
        brokerName: "",
        needUploadAgentDocuments: false,
        agentLocations: [],
        // buyerLocation: {},
        twillioIdentity: "",
        refusedToBeLead: false,
        showAnalytic: false,
        agentDocuments: [],
        preferences: {
          tagId: "",
          title: "",
          icon: "",
          value: ""
        },

        specialties: "",
        facebook: "",
        linkedin: "",
        agentSince: "",
        brokerageAddress: "",
        otherLicenses: "",
        businessPhone: "",
        brokeragePhone: "",
        managingBrokerName: "",
        brokerLicenseNumberAndState: "",
        licenceApproved: false
      };

      commit("setUser", user);
      commit("setFilters", []);

      if (window.Intercom) {
        window.Intercom("shutdown");
      }
    }
  },

  getters: {
    doneProperties: state => {
      return state.properties;
    },

    getFilters: state => {
      return state.filters;
    },

    getUser: state => {
      return state.user;
    },

    layout(state) {
      return state.layout;
    }
  }
});
